
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class MicrosoftSubscriptionModel extends Model<MicrosoftSubscriptionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'initialOrderData', type: 'string' },
		{ name: 'newCommerceOrderId', type: 'string' },
		{ name: 'subscriptionId', type: 'number' },
		{ name: 'productPlanEndDate', type: 'Date' },
		{ name: 'crayonAutoRenewEnabled', type: 'boolean' },
		{ name: 'productPlanIsTerminated', type: 'boolean' },
		{ name: 'created', type: 'Date', isHidden: true }
	];
	[key: string]: any;
	
	public id?: string;
	public productPlanId?: string;
	public initialOrderData: string;
	public newCommerceOrderId?: string;
	public subscriptionId?: number;
	public productPlanEndDate?: Date;
	public crayonAutoRenewEnabled: boolean;
	public productPlanIsTerminated: boolean;
	public created?: Date;
    
	constructor(){
		super();
		this.id = undefined;
		this.productPlanId = undefined;
		this.initialOrderData = '';
		this.newCommerceOrderId = undefined;
		this.subscriptionId = undefined;
		this.productPlanEndDate = undefined;
		this.crayonAutoRenewEnabled = false;
		this.productPlanIsTerminated = false;
		this.created = undefined;
		
	}
	getProperties(){
		return MicrosoftSubscriptionModel.classProperties;
	}
}

